var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.navData),function(item,index){return _c('el-breadcrumb-item',{key:index,staticClass:"row"},[_c('span',{staticClass:"word",on:{"click":function($event){return _vm.goPath(item)}}},[_vm._v(_vm._s(item.title))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }